module.exports = __webpack_public_path__ + "img/blue_069.e598f06d.png";